import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { addAttachmentsByArticleIdAsync, createArticleAsync, createArticleLocationStockAsync, deleteArticleAttachmentAsync, deleteArticleByIdAsync, deleteArticleLocationStockAsync, getAllArticalsAsync, getAllArticleLocationStockByArticleIdAsync, getAllArticlesAsync, getAllAttachmentsByArticleIdAsync, getAllInStockArticlesAsync, getAllOrdersByArticleIdAsync, getAllOutOfStockArticlesAsync, getArticalByIdAsync, getArticleLocationStockByIdAsync, getArticleNumberAsync, getWorkshopLocationAsync, updateArticleAsync, updateArticleLocationStockAsync } from './ArticleThunk';
import { AppConsts } from '@application/common/constants/app-consts';
const articleRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
};
const articleOutOfStockRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
};
const initialState = {
    status: APIStatus.IDLE,
    articleRequest: articleRequest,
    articleOutOfStockRequest: articleOutOfStockRequest
};
export const articalSlice = createSlice({
    name: 'artical',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllArticalsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllArticalsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Articles = action.payload;
            state.ArticlesDropDown = action.payload.map((artical) => {
                return {
                    label: `${artical.articleNumber + ' - ' + artical.name}`,
                    value: artical.id
                };
            });
        })
            .addCase(getAllArticalsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getArticalByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getArticalByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Article = action.payload;
            state.unchangedArticle = action.payload;
        })
            .addCase(getArticalByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getArticleNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getArticleNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.articleNumber = action.payload.toString();
        })
            .addCase(getArticleNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createArticleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createArticleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.CreateArticle = action.payload;
        })
            .addCase(createArticleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateArticleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateArticleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.UpdateArticle = action.payload;
            state.unchangedArticle = action.payload;
        })
            .addCase(updateArticleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllInStockArticlesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInStockArticlesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.inStockArticles = action.payload;
        })
            .addCase(getAllInStockArticlesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllOutOfStockArticlesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllOutOfStockArticlesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.outOfStockArticles = action.payload;
        })
            .addCase(getAllOutOfStockArticlesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllAttachmentsByArticleIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllAttachmentsByArticleIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.articleAttachments = action.payload;
        })
            .addCase(getAllAttachmentsByArticleIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(addAttachmentsByArticleIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addAttachmentsByArticleIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.uploadAttachment = action.payload;
        })
            .addCase(addAttachmentsByArticleIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteArticleAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteArticleAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deleteAttachment = action.payload;
        })
            .addCase(deleteArticleAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteArticleByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteArticleByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteArticleByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllOrdersByArticleIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllOrdersByArticleIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.ArticleOrders = action.payload;
        })
            .addCase(getAllOrdersByArticleIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllArticlesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllArticlesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.articles = action.payload;
        })
            .addCase(getAllArticlesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllArticleLocationStockByArticleIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllArticleLocationStockByArticleIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.articleLocationStocks = action.payload;
        })
            .addCase(getAllArticleLocationStockByArticleIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkshopLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkshopLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workshopLocationsForArticleLocationStocksDropdown = action.payload.map((workshoplocation) => {
                return {
                    label: `${workshoplocation.location}`,
                    value: workshoplocation.id
                };
            });
        })
            .addCase(getWorkshopLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createArticleLocationStockAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createArticleLocationStockAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(createArticleLocationStockAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getArticleLocationStockByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getArticleLocationStockByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.articleLocationStock = action.payload;
        })
            .addCase(getArticleLocationStockByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateArticleLocationStockAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateArticleLocationStockAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.articleLocationStock = action.payload;
        })
            .addCase(updateArticleLocationStockAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteArticleLocationStockAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteArticleLocationStockAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteArticleLocationStockAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default articalSlice.reducer;
